import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useState } from 'react';

function useGoogleMaps(apiKey, version = 'weekly') {
  const [isLoaded, setIsLoaded] = useState(false);
  const [googleMaps, setGoogleMaps] = useState(null);

  useEffect(() => {
    let mounted = true;

    const loader = new Loader({ apiKey, version });

    loader.load().then(() => {
      if (mounted) {
        setIsLoaded(true);
        setGoogleMaps(google.maps);
      }
    });

    return () => {
      mounted = false;
    };
  }, [apiKey, version]);

  return { isLoaded, googleMaps };
}

export default useGoogleMaps;
